export type DebugLayer =
  | 'laneGuides'
  | 'connectors'
  | 'obstacleSpawnPoints'
  | 'collectibleSpawnPoints'
  | 'decorationSockets'
  | 'dynamicEventSockets'
  | 'adSlots'
  | 'colliders';

export interface DebugConfig {
  /** Debug mode is available in dev builds and via ?debug=1 in production builds. */
  readonly startEnabled: boolean;
  readonly defaultLayers: Readonly<Record<DebugLayer, boolean>>;
  readonly statsUpdateInterval: number;
  /** `terrain`: segment surfaces, pits and ceilings; `hazard`: moving hazards (both drawn with the colliders layer). */
  readonly colors: Readonly<Record<DebugLayer | 'connectorIn' | 'connectorOut' | 'player' | 'terrain' | 'hazard', string>>;
}

export const DEBUG_CONFIG: DebugConfig = {
  startEnabled: import.meta.env.VITE_DEBUG === 'true',
  defaultLayers: {
    laneGuides: true,
    connectors: true,
    obstacleSpawnPoints: true,
    collectibleSpawnPoints: false,
    decorationSockets: true,
    dynamicEventSockets: true,
    adSlots: true,
    colliders: true,
  },
  statsUpdateInterval: 0.2,
  colors: {
    laneGuides: '#00e5ff',
    connectors: '#ffffff',
    connectorIn: '#2ecc71',
    connectorOut: '#e74c3c',
    obstacleSpawnPoints: '#ff8c00',
    collectibleSpawnPoints: '#ffd400',
    decorationSockets: '#3d7eff',
    dynamicEventSockets: '#d63dff',
    adSlots: '#00ffc8',
    colliders: '#ff2d55',
    player: '#39ff14',
    terrain: '#ffa31a',
    hazard: '#ff00d4',
  },
};
